import { from, Observable } from 'rxjs';
import { map, toArray } from 'rxjs/operators';

export function objectToArray<T>(data: any): Observable<T[]> {
  const dataKeys = Object.keys(data);
  return from(dataKeys).pipe(
    map(key => {
      const res = data[key];
      res.keyName = key;
      return res;
    }),
    toArray()
  );
}
